import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Link');
function Link(_ref) {
  let {
    children,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    onClick,
    isDisabled,
    href,
    target,
    bold,
    variation,
    type = 'body',
    isTruncated = false,
    underline = false,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);

  //Overrides
  const override = getOverrides(overridesProp, Link.overrides);

  // Classes
  const rootClassName = classnames(classes.root, classNameProp, classes[type], {
    [classes.isDisabled]: isDisabled,
    [classes.truncated]: isTruncated,
    [classes.bold]: bold,
    [classes.underline]: underline,
    [classes.primary]: variation === 'primary'
  });
  const rootProps = useMemo(() => ({
    ...props,
    className: rootClassName,
    onClick: isDisabled ? null : onClick,
    ...override.root
  }), [isDisabled, onClick, override.root, props, rootClassName]);
  if (href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: href,
      target: target
    }, rootProps), children);
  } else {
    return /*#__PURE__*/React.createElement("button", _extends({
      type: "button"
    }, rootProps), children);
  }
}
Link.overrides = ['root'];
process.env.NODE_ENV !== "production" ? Link.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle', 'body1', 'body', 'button', 'caption', 'captionMedium', 'badges', 'overline']),
  isDisabled: PropTypes.bool,
  /** Render the component as a tag <a/> with href */
  href: PropTypes.string,
  /** native <a/> target */
  target: PropTypes.string,
  isTruncated: PropTypes.bool,
  bold: PropTypes.bool,
  underline: PropTypes.bool,
  variation: PropTypes.oneOf(['primary'])
} : void 0;
export default /*#__PURE__*/React.memo(Link);